import actionsTypes from '../constants/ActionsTypes';

const actionsSlide = {
  setBackground: background => ({
    type: actionsTypes.SET_BACKGROUND,
    background
  }),
  setBackgroundImage: background => ({
    type: actionsTypes.SET_BACKGROUND_IMAGE,
    background
  }),
  setContent: (content, index) => ({
    type: actionsTypes.SET_CONTENT,
    content,
    index
  }),
  setHtml: (index, html) => ({
    type: actionsTypes.SET_HTML,
    index,
    html
  }),
  setColumnContent: (content, index, indexLine, indexColumn, hasAudio) => ({
    type: actionsTypes.SET_COLUMN_CONTENT,
    index,
    indexLine,
    indexColumn,
    content,
    hasAudio
  }),
  setColumnHtml: (index, html, indexLine, indexColumn, hasAudio) => ({
    type: actionsTypes.SET_COLUMN_HTML,
    index,
    indexLine,
    indexColumn,
    html,
    hasAudio
  }),
  setBlockPosition: (x, y, index) => ({
    type: actionsTypes.SET_BLOCK_POSITION,
    x,
    y,
    index
  }),
  setBlockEndPosition: (x, y, index) => ({
    type: actionsTypes.SET_BLOCK_END_POSITION,
    x,
    y,
    index
  }),
  setBlockControlPosition: (x, y, index) => ({
    type: actionsTypes.SET_BLOCK_CONTROL_POSITION,
    x,
    y,
    index
  }),
  setBlockSize: (width, height, index) => ({
    type: actionsTypes.SET_BLOCK_SIZE,
    width,
    height,
    index
  }),
  setBlockIndex: index => ({
    type: actionsTypes.SET_BLOCK_INDEX,
    index
  }),
  addBlock: (block, blockIndex = `block${Date.now()}`) => ({
    type: actionsTypes.ADD_BLOCK,
    block,
    blockIndex
  }),
  deleteSelectedBlock: () => ({
    type: actionsTypes.DELETE_SELECTED_BLOCK
  }),
  setArrowBlockPosition: keyPressed => ({
    type: actionsTypes.SET_ARROW_BLOCK_POSITION,
    keyPressed
  }),
  setSlideIndex: index => ({
    type: actionsTypes.SET_SLIDE_INDEX,
    index
  }),
  addSlide: toEnd => ({
    type: actionsTypes.ADD_SLIDE,
    toEnd
  }),
  setSelectedCell: cell => ({
    type: actionsTypes.SET_SELECTED_CELL,
    cell
  }),
  setTable: (table, lines, columns) => ({
    type: actionsTypes.SET_TABLE,
    table,
    lines,
    columns
  }),
  setAudioAddMode: mode => ({
    type: actionsTypes.SET_AUDIO_ADD_MODE,
    mode
  }),
  setQuizAnswerHtml: (index, html, indexAnswer) => ({
    type: actionsTypes.SET_QUIZ_ANSWER_HTML,
    index,
    html,
    indexAnswer
  }),
  setQuizAnswerFormat: (index, format, indexAnswer) => ({
    type: actionsTypes.SET_QUIZ_ANSWER_FORMAT,
    index,
    format,
    indexAnswer
  }),
  setQuizAnswerContent: (index, content, indexAnswer) => ({
    type: actionsTypes.SET_QUIZ_ANSWER_CONTENT,
    index,
    content,
    indexAnswer
  }),
  setSlide: (
    blocks,
    background = '#fff',
    backgroundImage = null,
    controls = {},
    overview = false,
    naoSequencial = false,
    plataforma = 'AMBOS',
    publico = false,
    args = {}
  ) => ({
    type: actionsTypes.SET_SLIDE,
    blocks,
    background,
    backgroundImage,
    controls,
    overview,
    naoSequencial,
    plataforma,
    publico,
    args
  }),
  removeSlide: () => ({
    type: actionsTypes.REMOVE_SLIDE
  }),
  setSlides: slides => ({
    type: actionsTypes.SET_SLIDES,
    slides
  }),
  setSlideId: (id, slideIndex = null) => ({
    type: actionsTypes.SET_SLIDE_ID,
    id,
    slideIndex
  }),
  setSlideIdParam: slideId => ({
    type: actionsTypes.SET_SLIDE_ID_PARAM,
    slideId
  }),
  setToast: toast => ({
    type: actionsTypes.SET_TOAST,
    toast
  }),
  setBlockImage: blockImage => ({
    type: actionsTypes.SET_BLOCK_IMAGE,
    blockImage
  }),
  setHideBlockSize: (width, height, blockIndex, hideBlockIndex) => ({
    type: actionsTypes.SET_HIDE_BLOCK_SIZE,
    width,
    height,
    blockIndex,
    hideBlockIndex
  }),
  setBlock: (block, blockKey) => ({
    type: actionsTypes.SET_BLOCK,
    block,
    blockKey
  }),
  // Vídeo pronto: o worker terminou de comprimir. Seta a url no bloco e limpa o
  // flag "processing" (atualização ao vivo, em qualquer slide que contenha o bloco).
  setBlockProcessed: (blockKey, url) => ({
    type: actionsTypes.SET_BLOCK_PROCESSED,
    blockKey,
    url
  }),
  setDefaultBackground: background => ({
    type: actionsTypes.SET_DEFAULT_BACKGROUND,
    background
  }),
  addBlockSelected: index => ({
    type: actionsTypes.ADD_BLOCK_SELECTED,
    index
  }),
  setControlIsPressed: isPressed => ({
    type: actionsTypes.SET_CONTROL_IS_PRESSED,
    isPressed
  }),
  resetBlocksSelected: () => ({
    type: actionsTypes.RESET_BLOCKS_SELECTED
  }),
  deleteBlock: blockKey => ({
    type: actionsTypes.DELETE_BLOCK,
    blockKey
  }),
  setSlidesCount: slidesCount => ({
    type: actionsTypes.SET_SLIDES_COUNT,
    slidesCount
  }),
  setHideBlockPosition: (x, y, blockIndex, hideBlockIndex) => ({
    type: actionsTypes.SET_HIDE_BLOCK_POSITION,
    x,
    y,
    blockIndex,
    hideBlockIndex
  }),
  setSlideControls: controls => ({
    type: actionsTypes.SET_CONTROLS_SLIDE,
    controls
  }),
  copyBlocks: () => ({
    type: actionsTypes.COPY_BLOCKS
  }),
  pasteBlocks: () => ({
    type: actionsTypes.PASTE_BLOCKS
  }),
  undo: () => ({
    type: actionsTypes.UNDO
  }),
  redo: () => ({
    type: actionsTypes.REDO
  }),
  setIsDragging: isDragging => ({
    type: actionsTypes.SET_IS_DRAGGING,
    isDragging
  }),
  setInInput: inInput => ({
    type: actionsTypes.SET_IN_INPUT,
    inInput
  }),
  setIdQuestaoSlide: idQuestaoSlide => ({
    type: actionsTypes.SET_ID_QUESTAO_SLIDE,
    idQuestaoSlide
  }),
  setAnimations: animations => ({
    type: actionsTypes.SET_ANIMATIONS_SLIDE,
    animations
  })
};

export default actionsSlide;
